import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useAuth } from '../../../../context/AuthContext';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { API_BASE_URL } from "../../../../Helpers/apiConfig";

export const UserCourseLayout = () => {
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation()
    const [courses, setCourses] = useState([]);
    const [activeCourse, setactiveCourse] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [showScrollTop, setShowScrollTop] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleClick = (id) => {
        navigate(`/user/course/subject/${id}`);
    };
    const handleClickAlert = event => {
        event.preventDefault();
        Swal.fire({
            title: "Hata",
            text: "Bu bölümü satın almadınız!",
            icon: "error",
        });
    };

    useEffect(() => {

        const fetchdata = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = `${API_BASE_URL}/user/Content/GetCourse`;
                //let url = "https://localhost:7004/api/user/Content/GetCourse";
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {

                            const fetchedCourses = res.data['data']['courses'];
                            setCourses(fetchedCourses);

                            // activeCourse belirleme kısmı güncellendi
                            if (user?.educational?.courseId) {
                                const matchedCourse = fetchedCourses.find(c => c.id === user.educational.courseId);
                                // Eğer eşleşen kurs bulunamazsa hata vermemesi için API'den geleni kullan
                                setactiveCourse(matchedCourse || res.data['data']['active']);
                            } else {
                                setactiveCourse(res.data['data']['active']);
                            }
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }
        fetchdata();

        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener("contextmenu", handleContextMenu);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);

    // kullanıcının erişebildiği course id'leri
    const userCourseIds = user?.educationals?.map(x => x.courseId) || [];

    // active kursu en üste taşı
    const sortedCourses = [...courses].sort((a, b) => {
        if (a.id === activeCourse?.id) return -1;
        if (b.id === activeCourse?.id) return 1;
        return 0;
    });

    const normalizeTr = (str) => (str || "").toLocaleLowerCase('tr-TR');

    const filteredCourses = sortedCourses.filter((dt) =>
        normalizeTr(dt.courseName).includes(normalizeTr(searchTerm.trim()))
    );

    return (
        <div>
            <br />

            {!loading && (
                <div>
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control shadow-sm"
                            placeholder="Kurs ara..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    {filteredCourses.length === 0 && (
                        <div className="text-center text-muted py-4">Aramanızla eşleşen kurs bulunamadı.</div>
                    )}

                    {filteredCourses && filteredCourses.map((dt) => {
                        const isActiveCourse = dt.id === activeCourse?.id;
                        const hasAccess = userCourseIds.includes(dt.id);

                        if (isActiveCourse) {
                            return (
                                <div class="card" style={{ marginTop: "2%", backgroundColor: "Cornsilk" }}>
                                    <div class="card-body">
                                        <p class="card-text">
                                            <div class="row">
                                                <div class="col-md-9 d-flex flex-column justify-content-center text-left">
                                                    <div class="card-body">
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    '<p class="card-title text-center"><b>' +
                                                                    dt.courseName +
                                                                    ' #Mevcut Kurs' +
                                                                    "</b></p>",
                                                            }}
                                                        ></div>
                                                        <hr />
                                                        <p class="card-text">
                                                            <b>{dt.courseDesc}</b>
                                                        </p>
                                                        <div className="d-flex justify-content-center">
                                                            <a onClick={() => handleClick(dt.id)} id={dt.id} class="btn btn-primary">
                                                                {t('showsubjects')}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 d-flex justify-content-center align-items-center">
                                                    <img
                                                        style={{ maxHeight: "100px" }}
                                                        src={dt.featuredImage}
                                                        class="img-fluid rounded-start"
                                                        alt="..."
                                                    />
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            )
                        }
                        else



                            if (hasAccess) {
                                return (
                                    <div class="card" style={{ marginTop: "2%", backgroundColor: "Lavender" }}>
                                        <div class="card-body">
                                            <p class="card-text">
                                                <div class="row">
                                                    <div class="col-md-9 d-flex flex-column justify-content-center text-left">
                                                        <div class="card-body">
                                                            <div dangerouslySetInnerHTML={{ __html: '<h5 class="card-title text-center">' + dt.courseName + ' # Erişim hakkınız var</h5>' }}></div>
                                                            <hr />
                                                            <p class="card-text">
                                                                <b>{dt.courseDesc}</b>
                                                            </p>
                                                            <div className="d-flex justify-content-center">
                                                                <a onClick={() => handleClick(dt.id)} id={dt.id} class="btn btn-primary">
                                                                    {t('showsubjects')}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 d-flex justify-content-center align-items-center">
                                                        <img
                                                            style={{ maxHeight: "100px" }}
                                                            src={dt.featuredImage}
                                                            class="img-fluid rounded-start"
                                                            alt="..."
                                                        />
                                                    </div>
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div class="card" style={{ marginTop: "2%", backgroundColor: "Gainsboro" }}>
                                        <div class="card-body">
                                            <p class="card-text">
                                                <div class="row">
                                                    <div class="col-md-9 d-flex flex-column justify-content-center text-left">
                                                        <div class="card-body">
                                                            <div dangerouslySetInnerHTML={{ __html: '<h5 class="card-title text-center">' + dt.courseName + '</h5>' }}></div>
                                                            <hr />
                                                            <p class="card-text">
                                                                <b>{dt.courseDesc}</b>
                                                            </p>
                                                            <div className="d-flex justify-content-center">
                                                                <a onClick={handleClickAlert} id={dt.id} class="btn btn-primary">
                                                                    {t('showsubjects')}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 d-flex justify-content-center align-items-center">
                                                        <img
                                                            style={{ maxHeight: "100px" }}
                                                            src={dt.featuredImage}
                                                            class="img-fluid rounded-start"
                                                            alt="..."
                                                        />
                                                    </div>
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                )
                            }
                    })}
                </div >
            )}
            {showScrollTop && (
                <button
                    onClick={scrollToTop}
                    className="btn btn-primary shadow"
                    style={{
                        position: 'fixed',
                        bottom: '40px',
                        right: '40px',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}
                    title="Yukarı Çık"
                >
                    <i className="pi pi-arrow-up" style={{ fontSize: '1.2rem' }}></i>
                </button>
            )}
        </div >
    );
}

export default UserCourseLayout;